import React, { useState, useEffect } from "react";
import {
  ZapparCamera,
  InstantTracker,
  ZapparCanvas,
} from "@zappar/zappar-react-three-fiber";
import { useThree } from "@react-three/fiber";
import { TextureLoader } from "three";

function Skybox() {
  const { scene } = useThree();

  useEffect(() => {
    const textureLoader = new TextureLoader();
    textureLoader.load("/images/env-bg.jpg", (texture) => {
      scene.background = texture;
    });

    return () => {
      scene.background = null;
    };
  }, [scene]);

  return null;
}

function App() {
  const [placementMode, setPlacementMode] = useState(true);
  const [skyboxEnabled, setSkyboxEnabled] = useState(false);

  return (
    <>
      <ZapparCanvas>
        <ZapparCamera />
        {skyboxEnabled && <Skybox />}
        <InstantTracker
          placementMode={placementMode}
          placementCameraOffset={[0, 0, -5]}
        >
          <mesh>
            <sphereBufferGeometry />
            <meshStandardMaterial color="hotpink" />
          </mesh>
          {!placementMode && (
            <mesh position={[0, 1, -3]} scale={2}>
              <boxBufferGeometry />
              <meshStandardMaterial color="blue" />
            </mesh>
          )}
        </InstantTracker>
        <directionalLight position={[2.5, 8, 5]} intensity={1.5} />
      </ZapparCanvas>
      <div
        id="zappar-placement-ui"
        onClick={() => {
          setPlacementMode((currentPlacementMode) => !currentPlacementMode);
        }}
        onKeyDown={() => {
          setPlacementMode((currentPlacementMode) => !currentPlacementMode);
        }}
        role="button"
        tabIndex={0}
      >
        Tap here to
        {placementMode ? " place " : " pick up "}
        the object
      </div>
      <div
        id="zappar-skybox-ui"
        onClick={() => {
          setSkyboxEnabled((currentSkyboxEnabled) => !currentSkyboxEnabled);
        }}
        onKeyDown={() => {
          setSkyboxEnabled((currentSkyboxEnabled) => !currentSkyboxEnabled);
        }}
        role="button"
        tabIndex={0}
        style={{
          position: "fixed",
          bottom: "20px",
          right: "20px",
          background: "rgba(0, 0, 0, 0.7)",
          color: "white",
          padding: "10px 15px",
          borderRadius: "5px",
          cursor: "pointer",
          fontSize: "14px",
          zIndex: 1000,
        }}
      >
        {skyboxEnabled ? "Disable" : "Enable"} Skybox
      </div>
    </>
  );
}

export default App;
